export { colorForUser } from '@tinycld/core/lib/util/color'
